import './NoData.sass';

export default function NoData() {
	return <div className='page-nodata'>No data</div>;
}
